<template>
  <div class="body">
    <!-- PC -->
    <div class="time" v-if="false">
      <EndDate :endDate="endDate"></EndDate>
    </div>
    <!-- 手机 -->
    <div class="timeM" v-if="false">
      <EndDateM :endDate="endDate"></EndDateM>
    </div>
  </div>
</template>
<script>
import EndDate from "./common/endDate.vue";
import EndDateM from "./common/endDateM.vue";
import { perfix } from "../utils/common.js";
export default {
  components: {
    EndDate,
    EndDateM,
  },
  data() {
    return {
      endDate: "2023-10-27", //结束时间
      phoneType: true,
    };
  },
  methods: {},
  created() {
    //判断是手机还是电脑访问,加载不同的组件
    const cellphoneType = perfix();
    if (cellphoneType.length == 7) {
      this.phoneType = !this.phoneType;
    }
  },
};
</script>

<style lang="scss" scoped>
.time {
  width: 325px;
  height: 150px;
  margin: 0 auto;
}
.timeM {
  width: 61.34vw;

  margin: 0 auto;
}
</style>
